import { useMusicControl } from '../hooks/useMusicControl';
import { cn } from '../lib/utils';

interface MusicControlIndicatorProps {
  screenId: string;
  locationId: string;
  groupId?: number;
  className?: string;
}

export function MusicControlIndicator({
  screenId,
  locationId,
  groupId,
  className,
}: MusicControlIndicatorProps) {
  const { controlInfo, isLoading } = useMusicControl(screenId, locationId, groupId);

  if (isLoading || !controlInfo) return null;

  const getStatusInfo = (): { label: string; color: string } => {
    if (controlInfo.is_owner) {
      return {
        label: 'Controller',
        color: 'text-green-500',
      };
    }

    if (controlInfo.has_control) {
      return {
        label: 'Has Control',
        color: 'text-blue-500',
      };
    }

    if (controlInfo.request_status === 'pending') {
      return {
        label: 'Request Pending',
        color: 'text-yellow-500',
      };
    }

    return {
      label: 'Independent',
      color: 'text-gray-500',
    };
  };

  const { label, color } = getStatusInfo();

  return (
    <div
      className={cn(
        'flex items-center gap-1.5 text-xs',
        color,
        className
      )}
      title={label}
    >
      <span>{label}</span>
    </div>
  );
}